export const coachReplyIdentity = (message = {}) => {
  if (message?._id != null) return String(message._id);
  if (!message?.created_at) return '';
  const date = new Date(message.created_at);
  return Number.isNaN(date.getTime()) ? String(message.created_at) : date.toISOString();
};

const isConversationalCoachReply = message => (
  message?.role === 'coach'
  && message?.kind !== 'ai_action_trace'
  && typeof message?.text === 'string'
  && message.text.trim().length > 0
);

export const latestRegeneratableCoachReply = (conversation = []) => {
  let reply = null;
  for (let index = conversation.length - 1; index >= 0; index -= 1) {
    const message = conversation[index];
    if (!reply && isConversationalCoachReply(message)) {
      reply = message;
      continue;
    }
    if (reply && message?.role === 'user' && !message?.client_pending) return reply;
    if (!reply && message?.role === 'user') return null;
  }
  return null;
};
